<script>
import { Popup, Toast, Icon } from "vant";
import { loginPhoneSendCode, loginPhoneVerifyCode } from "@/api/login.js";
import { setToken, setUserInfo } from "@/utils/common.js";
import Verify from "@/components/verifition/Verify.vue";
import { dataGather } from "@/utils/logTracking.js";

export default {
  name: "LoginPopup",
  components: { Popup, Icon, Verify },
  computed: {
    captchaWidth() {
      return `${Math.min(window.innerWidth - 30, 330)}px`;
    },
  },
  data() {
    return {
      showLogin: false,
      form: {
        phone: "",
        code: "",
      },
      time: 60,
    };
  },
  methods: {
    Show() {
      this.showLogin = true;
    },
    login() {
      const { code, phone } = this.form;
      if (phone.length !== 11) {
        Toast("请输入正确手机号码");
        return;
      }
      if (code === "") {
        Toast("请输入验证码");
        return;
      }
      let params = {
        phone: phone,
        verifyCode: code,
        loginType: "1",
      };
      loginPhoneVerifyCode(params)
        .then((r) => {
          let userNurseLoginInfo = r.userNurseLoginInfo;
          setUserInfo(userNurseLoginInfo);
          setToken(userNurseLoginInfo.token);
          Toast.success("登录成功");
          dataGather("NRCU000", "NRCU000-003", { eventName: "登录成功" });
          this.$emit("loginSuccess", userNurseLoginInfo);
          this.showLogin = false;
        })
        .catch(() => {});
    },
    verifyShow() {
      if (this.time !== 60) {
        return;
      }
      if (this.form.phone.length !== 11) {
        Toast("请输入正确的手机号！");
        return;
      }
      this.$refs.verify.show();
    },
    verifySuccess(res) {
      this.sendMsg({ captchaVO: res });
    },
    sendMsg(verifyParams) {
      if (!verifyParams) verifyParams = {};
      if (this.time !== 60) {
        return;
      }
      if (this.form.phone.length !== 11) {
        Toast("请输入正确的手机号！");
        return;
      }
      loginPhoneSendCode({
        loginType: "1",
        phone: this.form.phone,
        ...verifyParams,
      })
        .then((r) => {
          if (r == 0) {
            Toast("验证码发送失败，请重试");
            return;
          }
          if (r == 2 || r == 3) {
            Toast("请重新验证");
            this.$refs.verify.show();
            return;
          }
          Toast("验证码已发送");
          let DJS = setInterval(() => {
            if (this.time <= 0) {
              clearInterval(DJS);
              this.time = 60;
              return;
            }
            this.time--;
          }, 1000);
        })
        .catch((e) => {
          Toast(typeof e === "string" ? e : "发送失败，请重试");
        });
    },
    closeLogin() {
      this.showLogin = false;
    },
  },
};
</script>

<template>
  <div>
    <Popup
      :style="{ background: 'transparent', width: '100%' }"
      position="bottom"
      v-model="showLogin"
      :closeable="false"
      :close-on-click-overlay="true"
      get-container="body"
      @close="closeLogin"
    >
      <div class="nrc-login-popup">
        <h2>登录护理科研门诊</h2>
        <div class="nrc-login-field phone-field">
          <Icon name="phone-o" size="20" color="#999" />
          <input
            placeholder="请输入手机号"
            type="tel"
            v-model="form.phone"
            maxlength="11"
          />
        </div>
        <div class="code-row">
          <div class="nrc-login-field code-field">
            <Icon name="shield-o" size="20" color="#999" />
            <input
              v-model="form.code"
              placeholder="请输入验证码"
              type="text"
              maxlength="6"
            />
          </div>
          <button
            class="send-code-btn"
            :class="{ disabled: time !== 60 }"
            @click="verifyShow"
            :disabled="time !== 60"
          >
            {{ time === 60 ? "获取验证码" : time + "s" }}
          </button>
        </div>
        <button class="login-btn" @click="login()" v-track="'NRCU000|NRCU000-002|点击立即登录'">立即登录</button>
        <p class="privacy-text">
          登录即表示同意《<a
            href="https://hsj5m.hulian120.com/agreementUser.html"
            target="_blank"
            @click.stop
            >用户协议</a
          >》和《<a
            href="https://hsj5m.hulian120.com/agreementPrivacy.html"
            target="_blank"
            @click.stop
            >隐私政策</a
          >》
        </p>
      </div>
    </Popup>
    <Verify
      mode="pop"
      captchaType="blockPuzzle"
      :imgSize="{ width: captchaWidth, height: '155px' }"
      ref="verify"
      @success="verifySuccess"
    />
  </div>
</template>

<style scoped lang="scss">
.nrc-login-popup {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 16px 24px;
  border-radius: 20px 20px 0 0;
  background: #fff;

  h2 {
    margin: 0 0 22px;
    color: #333;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    text-align: center;
  }

  .nrc-login-field {
    display: flex;
    align-items: center;
    height: 46px;
    box-sizing: border-box;
    padding: 0 10px;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
    background: #fff;

    input {
      flex: 1;
      min-width: 0;
      height: 44px;
      margin-left: 8px;
      border: 0;
      outline: none;
      color: #333;
      font-size: 16px;
      background: transparent;
    }
  }

  .phone-field {
    width: 100%;
    margin-bottom: 16px;
  }

  .code-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .code-field {
    flex: 1;
    min-width: 0;
  }

  .send-code-btn {
    width: 100px;
    height: 46px;
    margin-left: 12px;
    border: 0;
    border-radius: 6px;
    color: #fff;
    background: #0E7490;
    font-size: 14px;
  }

  .send-code-btn.disabled {
    background: #7fb8c9;
  }

  .login-btn {
    width: 100%;
    height: 51px;
    border: 0;
    border-radius: 6px;
    color: #fff;
    background: #0E7490;
    font-size: 18px;
  }

  .privacy-text {
    margin: 10px 0 0;
    color: #999;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
  }

  .privacy-text a {
    color: #0e7490;
  }
}
</style>
